import { render, staticRenderFns } from "./fieldImagePreview.vue?vue&type=template&id=0597b28a&scoped=true"
import script from "./fieldImagePreview.vue?vue&type=script&lang=js"
export * from "./fieldImagePreview.vue?vue&type=script&lang=js"
import style0 from "./fieldImagePreview.vue?vue&type=style&index=0&id=0597b28a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0597b28a",
  null
  
)

export default component.exports